// extracted by mini-css-extract-plugin
export default {"modal":"yNBTAU","list":"SeaMQ8","item":"B07nUP","icon":"oarTr5","label":"EK6zF7","description":"aQpkAV","button":"_UP5qW"};